import { createEssentials } from '@wix/fe-essentials-standalone';
import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/panorama-client-web';
import { PremiumEssentialsProvider } from '@wix/premium-fed-sdk/@premium-essentials';
import { useHttpClientSiteLevel } from '@wix/premium-fed-sdk/@premium-essentials-adaptors';
import React, { useMemo } from 'react';
const globalConfig = createGlobalConfig();
// Only the i18n instance is shared across mounts (per locale, for the page
// session), so remounting (e.g. reopening a CDN modal) keeps its already-loaded
// translations instead of refetching.
// The rest (biLogger, httpClient) stays per mount — e.g. biLogger defaults set
// by one mount must not leak into the next.
const i18nCache = new Map();
const getSharedI18n = (language, essentials) => {
  if (!i18nCache.has(language)) {
    i18nCache.set(language, essentials.i18n);
  }
  return i18nCache.get(language);
};
export const PackagePickerEssentialsProvider = _ref => {
  let {
    children,
    siteGuid,
    artifactId,
    version,
    Trans,
    componentId,
    sentryDsn,
    locale,
    userId
  } = _ref;
  const language = locale ?? 'en';
  const essentials = useMemo(() => createEssentials({
    environment: {
      language,
      artifactId,
      version
    },
    i18n: {}
  }), [language, artifactId, version]);
  const i18n = getSharedI18n(language, essentials);
  const panoramaClient = useMemo(() => panoramaClientFactory({
    baseParams: {
      platform: PanoramaPlatform.Standalone,
      fullArtifactId: artifactId,
      artifactVersion: version,
      componentId,
      msid: siteGuid,
      uuid: userId
    },
    pluginParams: {
      sentry: window.Sentry,
      sentryDsn
    }
  }).withGlobalConfig(globalConfig).client().createClientForComponent(), [artifactId, version, componentId, siteGuid, userId, sentryDsn]);
  const {
    httpClient: signedHttpClient,
    isLoading
  } = useHttpClientSiteLevel({
    siteId: siteGuid,
    httpClientOptions: {
      ...essentials.httpClient.options
    }
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(PremiumEssentialsProvider, {
    Trans: Trans,
    i18n: i18n,
    biLogger: essentials.biLogger,
    httpClient: signedHttpClient ?? essentials.httpClient,
    panorama: panoramaClient
  }, children);
};
//# sourceMappingURL=PackagePickerEssentialsProvider.js.map